// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__O3zPW"};